export const refectionTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Réfection toiture Lévis',
  hero_h1: 'Réfection de toiture à Lévis — Garantie 10 ans',
  hero_subtitle: "Un projet majeur qui mérite un vrai expert. Soumission détaillée en 2h, garantie écrite 10 ans.",
  hero_cta: 'Obtenir ma soumission de réfection',
  hero_stat_1: '+500 réfections livrées',
  hero_stat_2: 'Garantie 10 ans',
  hero_stat_3: 'Certifié',

  // Checklist
  checklist_h2: "Comment savoir que c'est le temps de refaire sa toiture",
  checklist_intro: "Une réfection n'attend pas. À Lévis, retarder coûte plus cher chaque hiver.",
  checklist_item_1: "Toiture installée il y a 20 ans ou plus",
  checklist_item_2: 'Bardeaux soulevés, fendus ou manquants',
  checklist_item_3: 'Granules dans les gouttières au printemps',
  checklist_item_4: "Taches d'humidité au plafond",
  checklist_item_5: 'Affaissement ou bombement visible',
  checklist_item_6: "Inspection demandée par votre assureur",
  checklist_box: "Vous cochez 2 cases ou plus ? Demandez une inspection gratuite.",
  checklist_cta: 'Demander une inspection gratuite',

  // Prix
  prix_h2: "Prix d'une réfection de toiture à Lévis en 2026",
  prix_intro: "Voici les vraies fourchettes de prix qu'on facture à Lévis. Sans surprise.",
  prix_row1_type: 'Bungalow 1 200–1 500 pi² (bardeau)',
  prix_row1_price: '7 000 $ – 12 000 $',
  prix_row2_type: 'Cottage 1 800–2 200 pi² (bardeau)',
  prix_row2_price: '10 000 $ – 16 000 $',
  prix_row3_type: 'Maison 2 étages 2 500+ pi² (bardeau)',
  prix_row3_price: '13 000 $ – 22 000 $',
  prix_row4_type: 'Toiture tôle / métal (tous formats)',
  prix_row4_price: '14 000 $ – 37 000 $',
  prix_note: "Prix incluent main-d'œuvre, matériaux, retrait ancienne toiture, disposition débris, permis. Soumission finale signée avant début travaux.",
  prix_table_type: 'Type de maison',
  prix_table_price: 'Prix indicatif',

  // Process
  process_h2: "Notre processus de réfection, étape par étape",
  process_step1_num: '01',
  process_step1_title: 'Inspection gratuite',
  process_step1_subtitle: '48h',
  process_step1_desc: "Un couvreur expérimenté monte sur votre toit, prend photos, mesure, identifie tous les enjeux.",
  process_step2_num: '02',
  process_step2_title: 'Soumission détaillée',
  process_step2_subtitle: '2h après inspection',
  process_step2_desc: "Vous recevez par courriel : matériaux choisis, prix ligne par ligne, durée, garantie. Signé.",
  process_step3_num: '03',
  process_step3_title: 'Planification et matériaux',
  process_step3_subtitle: '1–2 semaines',
  process_step3_desc: "Une fois acceptée, on commande les matériaux et planifie la date selon la météo.",
  process_step4_num: '04',
  process_step4_title: "Retrait ancienne toiture",
  process_step4_subtitle: 'Jour 1',
  process_step4_desc: "On enlève tout jusqu'au pontage, on inspecte la structure, on remplace les sections pourries.",
  process_step5_num: '05',
  process_step5_title: 'Installation nouvelle toiture',
  process_step5_subtitle: 'Jour 1–3',
  process_step5_desc: "Membrane d'étanchéité, ventilation, solins métal, bardeaux ou tôle posés selon normes de la Régie du bâtiment du Québec.",
  process_step6_num: '06',
  process_step6_title: 'Nettoyage et garantie',
  process_step6_subtitle: 'Jour final',
  process_step6_desc: "Site nettoyé au magnétisme (zéro clou au sol). Garantie 10 ans remise signée.",

  // Matériaux
  materiaux_h2: 'Les marques de matériaux que nos partenaires installent à Lévis',
  materiaux_bp_title: 'BP Canada',
  materiaux_bp_desc: "Bardeau d'asphalte, fabriqué au Québec. Résistance garantie aux cycles gel-dégel.",
  materiaux_iko_title: 'IKO',
  materiaux_iko_desc: "Bardeau haut de gamme, garantie fabricant 30–50 ans. Le choix des couvreurs exigeants.",
  materiaux_soprema_title: 'Soprema',
  materiaux_soprema_desc: "Membrane élastomère, leader mondial de l'étanchéité. Pour toits plats sans compromis.",
  materiaux_note: 'Tous les matériaux utilisés par nos partenaires sont certifiés et garantis par leur fabricant.',

  // Garantie
  garantie_h2: 'Notre garantie écrite 10 ans, en clair',
  garantie_text: "On garantit la main-d'œuvre 10 ans pleins. Si une infiltration apparaît à cause d'un défaut de pose, on revient, on répare, sans frais. Garantie remise en main propre, signée, datée. Pas de petits caractères.",
  garantie_point1: 'Main-d\u0026rsquo;œuvre couverte 10 ans',
  garantie_point2: 'Matériaux couverts par garantie fabricant',
  garantie_point3: 'Réparation sans frais si défaut de pose',
  garantie_point4: 'Contrat signé et daté remis en main propre',

  // Témoignage
  temoin_text: "Notre toiture avait 24 ans et commençait à perdre des bardeaux à chaque tempête. On avait des taches au plafond de la chambre des enfants et l'assureur nous demandait une inspection. On a contacté trois couvreurs, mais seul notre couvreur partenaire a pris le temps de monter sur le toit, de prendre des photos de chaque problème, et de nous expliquer pourquoi le pontage était encore bon. Ils ont refait la toiture en bardeau BP en 2 jours, ont protégé nos plates-bandes, et ont nettoyé le terrain au magnétisme. Aujourd'hui, zéro fuite, zéro souci. La garantie de 10 ans est dans notre coffre-fort. Je recommande sans hésiter.",
  temoin_name: 'Sylvie et Marc T.',
  temoin_location: 'Pintendre',
  temoin_project: "Réfection complète bardeau, 1 800 pi², juin 2025",
  temoin_cta: 'Demander une soumission',

  // FAQ
  faq_h2: 'Questions fréquentes sur la réfection de toiture',
  faq_q1: 'Combien de temps prend une réfection complète ?',
  faq_a1: "Ça dépend de la superficie et de la complexité. Un bungalow standard : 1 à 2 jours. Une maison de 2 étages avec plusieurs pignons : 3 à 4 jours. La tôle métal prend un peu plus de temps car chaque panneau est coupé sur mesure. On vous donne un échéancier précis dans la soumission.",
  faq_q2: 'Faut-il quitter la maison pendant les travaux ?',
  faq_a2: "Non, pas nécessairement. Le bruit est président pendant la journée, mais vous pouvez rester chez vous. On protège vos accès, vos plantes et vos objets fragiles. Seule exception : si on doit remplacer le pontage dans certaines zones, on peut vous demander de vider un grenier temporairement.",
  faq_q3: 'Mon assurance couvre-t-elle la réfection ?',
  faq_a3: "L'usure normale n'est pas couverte. Par contre, si votre toiture a été endommagée par une tempête, du grêlon ou des vents forts, votre assurance peut couvrir tout ou partie des travaux. On vous aide à préparer le dossier avec un rapport photo détaillé et une attestation de notre inspecteur.",
  faq_q4: "Que faire si le pontage est endommagé sous l'ancienne toiture ?",
  faq_a4: "C'est exactement pourquoi on enlève l'ancienne toiture au complet avant la nouvelle. On inspecte le pontage planche par planche. Les sections pourries sont remplacées avant l'installation de la membrane d'étanchéité. C'est inclus dans notre soumission, pas de surprise.",
  faq_q5: 'Travaillez-vous en automne et début hiver ?',
  faq_a5: "On planifie les réfections complètes de mai à octobre pour les bardeaux, car ils ont besoin de températures au-dessus de 10°C pour sceller correctement. La tôle métal peut parfois être installée plus tard dans l'automne. On fait des réparations d'urgence toute l'année, oui.",

  // CTA Final
  cta_h2: 'Votre projet de réfection à Lévis commence ici',
  cta_subtitle: "Inspection gratuite, soumission claire en 2h, garantie 10 ans signée.",
  cta_button: 'Obtenir ma soumission',
  cta_phone: '418-476-9950',

  // Formulaire
  form_h2: 'Demandez votre soumission gratuite',
  form_subtitle: 'Remplissez le formulaire — on vous rappelle en 2h ouvrables.',
  form_success: 'Soumission envoyée !',
  form_success_sub: 'On vous rappelle dans les 2 prochaines heures ouvrables. Merci de nous faire confiance.',
  form_name_label: 'Nom complet',
  form_name_placeholder: 'Votre nom',
  form_phone_label: 'Téléphone',
  form_phone_placeholder: '418-476-9950',
  form_email_label: 'Courriel',
  form_email_placeholder: 'votre@email.com',
  form_service_label: 'Type de service',
  form_service_select: 'Sélectionnez un service',
  form_message_label: 'Description du projet',
  form_message_placeholder: 'Décrivez votre toiture, les problèmes observés, la superficie approximative...',
  form_char_count: '/500',

  // Header
  nav_home: 'Accueil',
  nav_services: 'Services',
  nav_about: 'À propos',
  nav_quote: 'Soumission',
  phone_number: '418-476-9950',
  cta_quote: 'Soumission gratuite',

  // Footer
  footer_brand: 'Couvreur-Lévis.com',
  footer_address: 'Lévis, QC, Canada',
  footer_email: 'contact@couvreur-levis.com',
  footer_services_title: 'Services',
  footer_link_refaction: 'Réfection toiture',
  footer_link_repair: 'Réparation',
  footer_link_flat: 'Toit plat',
  footer_link_metal: 'Tôle et métal',
  footer_link_inspection: 'Inspection',
  footer_links_title: 'Liens',
  footer_link_about: 'À propos',
  footer_link_quote: 'Soumission',
  footer_link_legal: 'Mentions légales',
  footer_link_privacy: 'Politique de confidentialité',
  footer_link_blog: 'Blog',
  footer_copyright: '© 2026 Couvreur-Lévis.com. Tous droits réservés.',
  footer_hours_title: 'Heures',
  footer_hours_week: 'Lun–Ven : 7h00 – 18h00',
  footer_hours_weekend: 'Sam–Dim : 8h00 – 16h00',
};

export default refectionTranslations;